/* NORAH · Videos do produto (sections/nr-product-videos.liquid)
   Cards: previa sem som quando entram na tela. Toque: abre o video com som, setas e fechar. */
(function () {
  'use strict';
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  // A Shopify so entrega o link do mp4 de 1080p; as versoes leves tem o mesmo link com outro nome.
  // Cards: 480p (3 MB). Tela aberta: 720p. Se algum link falhar, volta para o original.
  function lite(url, q) {
    if (!url) return url;
    if (q === 'sm') return url.replace('HD-1080p-7.2Mbps', 'SD-480p-1.5Mbps');
    return url.replace('HD-1080p-7.2Mbps', 'HD-720p-4.5Mbps');
  }

  function play(v) {
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function init(sec) {
    if (!sec || sec.getAttribute('data-nrpv') === '1') return;
    var track = sec.querySelector('.nr-pv__track');
    var cards = Array.prototype.slice.call(sec.querySelectorAll('.nr-pv__card'));
    if (!track || !cards.length) return;
    sec.setAttribute('data-nrpv', '1');

    var prev = sec.querySelector('.nr-pv__arrow--prev');
    var next = sec.querySelector('.nr-pv__arrow--next');
    var modal = sec.querySelector('.nr-pv__modal');
    var mv = modal ? modal.querySelector('.nr-pv__mvid') : null;
    var closeBtn = modal ? modal.querySelector('.nr-pv__x') : null;
    var autoplay = sec.getAttribute('data-autoplay') === '1' && !mqReduce.matches;
    var cur = -1;
    var opener = null;
    var isOpen = false;
    var inView = [];

    function srcFor(v) {
      return lite(v.dataset.md || v.dataset.sm, 'sm');
    }

    function inViewport(el) {
      var r = el.getBoundingClientRect();
      var h = window.innerHeight || document.documentElement.clientHeight;
      var w = window.innerWidth || document.documentElement.clientWidth;
      return r.bottom > 0 && r.top < h && r.right > 0 && r.left < w;
    }

    function startCard(v) {
      if (!autoplay || isOpen) return;
      if (!v.getAttribute('src')) {
        var s = srcFor(v);
        if (!s) return;
        v.src = s;
      }
      play(v);
    }

    function setupCards() {
      var vids = cards.map(function (c) { return c.querySelector('video'); });
      vids.forEach(function (v) {
        if (!v) return;
        v.addEventListener('error', function () {
          var orig = v.dataset.md || v.dataset.sm;
          if (orig && v.getAttribute('src') !== orig) {
            v.src = orig;
            play(v);
          }
        });
      });
      if (!autoplay) return;
      if (!('IntersectionObserver' in window)) {
        vids.forEach(function (v) { if (v) startCard(v); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            inView.push(v);
            startCard(v);
          } else {
            inView = inView.filter(function (x) { return x !== v; });
            v.pause();
          }
        });
      }, { threshold: 0.4 });
      vids.forEach(function (v) { if (v) io.observe(v); });
    }

    function pauseCards() {
      cards.forEach(function (c) {
        var v = c.querySelector('video');
        if (v) v.pause();
      });
    }

    function resumeCards() {
      cards.forEach(function (c) {
        var v = c.querySelector('video');
        if (v && inViewport(v)) startCard(v);
      });
    }

    function updateArrows() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth;
      prev.hidden = track.scrollLeft <= 2;
      next.hidden = max <= 2 || track.scrollLeft >= max - 2;
    }

    function step(dir) {
      var item = cards[0].parentNode;
      var w = item.getBoundingClientRect().width;
      var cs = window.getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      track.scrollBy({ left: dir * (w + gap), behavior: 'smooth' });
    }

    function open(i) {
      if (!modal || !mv) return;
      cur = (i + cards.length) % cards.length;
      var c = cards[cur];
      var src = c.getAttribute('data-modal');
      if (!src) return;
      var cv = c.querySelector('video');
      isOpen = true;
      pauseCards();
      mv.poster = cv ? cv.getAttribute('poster') || '' : '';
      mv.setAttribute('data-orig', src);
      mv.src = lite(src, 'md');
      mv.muted = false;
      modal.hidden = false;
      document.documentElement.classList.add('nr-pv-lock');
      play(mv);
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      mv.pause();
      mv.removeAttribute('src');
      mv.load();
      modal.hidden = true;
      document.documentElement.classList.remove('nr-pv-lock');
      resumeCards();
      if (opener && opener.focus) opener.focus();
    }

    cards.forEach(function (c, i) {
      c.addEventListener('click', function () {
        opener = c;
        open(i);
      });
    });

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);

    if (modal) {
      modal.addEventListener('click', function (e) {
        var t = e.target;
        if (t.closest && t.closest('[data-close]')) {
          close();
          return;
        }
        var nav = t.closest ? t.closest('.nr-pv__nav') : null;
        if (nav) open(cur + parseInt(nav.getAttribute('data-dir'), 10));
      });
      document.addEventListener('keydown', function (e) {
        if (!isOpen) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft') open(cur - 1);
        else if (e.key === 'ArrowRight') open(cur + 1);
      });
      if (mv) {
        mv.addEventListener('error', function () {
          var orig = mv.getAttribute('data-orig');
          if (isOpen && orig && mv.getAttribute('src') !== orig) {
            mv.src = orig;
            play(mv);
          }
        });
        mv.addEventListener('ended', function () {
          if (cur < cards.length - 1) open(cur + 1);
        });
      }
    }

    setupCards();
    updateArrows();
  }

  function initAll() {
    var list = document.querySelectorAll('.nr-pv-wrap');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var w = e.target && e.target.querySelector ? e.target.querySelector('.nr-pv-wrap') : null;
    init(w);
  });
})();